export const CONTRACT_TRACKING = 'ContractTracking'

// A plan feature is on when the workspace subscription lists its code.
export const hasFeature = (subscription, code) =>
  !!subscription?.features?.some((feature) => feature.code === code)
